import React from 'react';

/*
 * CheckboxIcon — 24×24 square chassis with optional 15×10.41 checkmark vector.
 *
 * Renders both the icon (unchecked) and checkedIcon (checked) for MUI's
 * Checkbox via the .hd-checkbox-icon className. State styling (border colors,
 * hover/focus/error/disabled) lives in src/theme/components.ts → MuiCheckbox
 * styleOverrides which cascade through MUI's class names + custom .hd-checkbox-*
 * selectors. This component just contributes the SVG glyph + DOM hooks.
 *
 * Checkmark path data sourced verbatim from
 * the Figma source.json (any True variant's Vector
 * node). Fill is currentColor so the parent .hd-checkbox-icon's `color` token
 * drives the glyph color (--hd-c-checkbox-check-fg).
 */
export const CheckboxIcon: React.FC<{ checked?: boolean }> = ({ checked = false }) => (
  <span className={`hd-checkbox-icon${checked ? ' hd-checkbox-icon--checked' : ''}`}>
    {checked && (
      <svg
        className="hd-checkbox-icon__glyph"
        width="15"
        height="10.41"
        viewBox="0 0 15 10.41"
        fill="none"
        aria-hidden
      >
        <path
          d="M 13.59 0 L 6 7.58 L 1.41 3 L 0 4.41 L 6 10.41 L 15 1.41 L 13.59 0 Z"
          fill="currentColor"
        />
      </svg>
    )}
  </span>
);
